import React from 'react';
import { ProfileDataItem } from 'pages/Profile/components/ProfileDataItem/ProfileDataItem';
import Label from 'components/form/Label/Label';
import moment from 'moment';

export const Dob = ({ dob, ...props }) => {
  const { Title, DisplayView } = ProfileDataItem;
  const dobDisplay = dob ? moment(dob).format('MMMM D, YYYY') : '';
  let profileDataItemClass = props.classNameOverwrites?.profileDataItem;
  return (
    <ProfileDataItem
      datatestid="profileDob"
      classNameOverwrites={profileDataItemClass?.profileDataItem}
    >
      <Title datatestid="dobLabel" labelType={profileDataItemClass?.title}>
        Date of birth
      </Title>
      <DisplayView
        datatestid="dobDisplay"
        classNameOverwrites={props.classNameOverwrites?.displayView}
      >
        <Label datatestid="dob" type="Body-1">
          {dobDisplay}
        </Label>
      </DisplayView>
    </ProfileDataItem>
  );
};
